export const INTERNAL_SEARCH_TOOL_CALL_NAME = 'internal-search' as const;
